import commonIcons from "../images/icons";
import React from "react";
import stateIcons from "../images/stateIcons";

export const getPowerIcon = (value) => {
    return (
        <>
            <img width={20} src={commonIcons.powerIcon} alt="power" />
            {value}
        </>
    );
}

export const getPerIcon = (value) => {
    return (
        <>
            <img width={20} src={commonIcons.perIcon} alt="per" />
            {value}
        </>
    )
}

export const getXperIcon = (value) => {
    return (
        <>
            <img width={20} src={commonIcons.xperIcon} alt="xper" />
            {value}
        </>
    )
}

export const getArbIcon = (value) => {
    return (
        <>
            <img width={20} src={commonIcons.arbIcon} alt="arb" />
            {value}
        </>
    )
}


export const getExtraPowerIcon = (value) => {
    return (
        <>
            <img width={20} src={commonIcons.extraPowerIcon} alt="power" />
            {value}
        </>
    );
}

// -------------------------------------------------------------------
// 상태
export const getGrayStateIcon = (value) => {
    return (
        <>
            <img width={14} src={stateIcons.notStarted} alt="" />
            {value}
        </>
    )
}

export const getGreenStateIcon = (value) => {
    return (
        <>
            <img width={14} src={stateIcons.end} alt="" />
            {value}
        </>
    )
}

export const getOrangeStateIcon = (value) => {
    return (
        <>
            <img width={14} src={stateIcons.active} alt="" />
            {value}
        </>
    )
}

export const getYellowStateIcon = (value) => {
    return (
        <>
            <img width={14} src={stateIcons.waiting} alt="" />
            {value}
        </>
    )
}

export const getRedStateIcon = (value) => {
    return (
        <>
            <img width={14}  src={stateIcons.cancel} alt="" />
            {value}
        </>
    );
}
// 상태 끝
// -------------------------------------------------------------------



// -------------------------------------------------------------------
// 등급
export const getEqualGradeIcon = () => {
    return (
        <>
            <img src={commonIcons.equalGrade} alt=""/>
        </>
    )
}

export const getMoreGradeIcon = () => {
    return (
        <>
            <img src={commonIcons.moreGrade} alt=""/>
        </>
    )
}
// 등급 끝
// -------------------------------------------------------------------

